<template>
  <el-table
    class="tree-grid fixed-table"
    row-key="id"
    ref="table"
    :data="newData"
    :row-class-name="getRowClassName"
    :class="{'sub-table': level > 1}"
    :show-header="level === 1"
    :height="level === 1 ? mixinTableHeight : 0"
    @selection-change="onSelectionChange"
  >
    <el-table-column
      :width="paddingWidth"
      v-if="level > 1"
    ></el-table-column>
    <el-table-column
      type="expand"
      width="32"
    >
      <template slot-scope="scope">
        <tree-grid
          :ref="`sub-table-${scope.row.id}`"
          :selections="scope.row._selections"
          @remove-menu="removeMenu"
          @move-menu="moveMenu"
          @change-menu="changeMenu"
          @reorder-menu="reorderMenu"
          @selection-change="(selection) => {
            onSubSelection(selection, scope.row);
          }"
          :data="scope.row.children"
          :level="level + 1"
          v-if="scope.row.children && scope.row.children.length > 0"
        >
        </tree-grid>
      </template>
    </el-table-column>
    <el-table-column
      type="selection"
      width="32"
      reserve-selection
    ></el-table-column>
    <el-table-column
      prop="name"
      :label="$t('management.menu.tool_bar_name')"
    >
      <template slot-scope="scope">
        <editable-info
          v-model="scope.row.name"
          @change="changeMenu(scope.row)"
        ></editable-info>
      </template>
    </el-table-column>
    <el-table-column
      prop="level"
      :label="$t('management.menu.tool_bar_level')"
      width="120"
    >
      <template slot-scope="scope">
        {{menu_level_name(scope.row.level)}}
      </template>
    </el-table-column>
    <el-table-column
      prop="icon"
      :label="$t('management.menu.icon')"
      width="84"
    >
      <template slot-scope="scope">
        <menu-icon-upload
          type="menuIcon"
          mode="small"
          v-model="scope.row.iconInfo"
          :menuLevel="scope.row.level"
          @icon-change="changeMenu(scope.row)"
        >
        </menu-icon-upload>
      </template>
    </el-table-column>
    <el-table-column
      prop="url"
      :label="$t('management.menu.url')"
      width="480"
    >
      <template slot-scope="scope">
        <editable-info
          v-model="scope.row.url"
          mode="url"
          @change="changeMenu(scope.row)"
        ></editable-info>
      </template>
    </el-table-column>
    <el-table-column
      prop="openWay"
      :label="$t('management.menu.open_way_label')"
      width="130"
    >
      <template slot-scope="scope">
        <el-select
          v-model="scope.row.openType"
          class="no-border"
          @change="changeOpenType(scope.row)"
          :disabled="scope.row.openType === -1"
        >
          <el-option
            :value="0"
            :label="$t('management.menu.open_type_name1')"
          ></el-option>
          <el-option
            :value="1"
            :label="$t('management.menu.open_type_name2')"
          ></el-option>
          <el-option
            :value="2"
            :label="$t('management.menu.open_type_name4')"
          ></el-option>
          <!-- <el-option :value="3"
            label="弹出新窗口"></el-option> -->
          <el-option
            :value="4"
            :label="$t('management.menu.open_type_name5')"
          ></el-option>
          <el-option
            :value="-1"
            :label="$t('management.menu.open_type_name3')"
            v-if="scope.row.openType === -1"
          ></el-option>
        </el-select>
      </template>
    </el-table-column>
    <el-table-column
      prop="showHome"
      :label="$t('management.menu.is_show')"
      width="100"
    >
      <template slot-scope="scope">
        <el-tooltip
          class="item"
          v-if="scope.row.level===1"
          effect="dark"
          :disabled="!(showToolLen>=4&&!scope.row.isShow)"
          :content="$t('management.menu.limit_prompt_level1')"
          placement="bottom"
        >
          <el-switch
            v-model="scope.row.isShow"
            @change="changeMenu(scope.row)"
            :disabled="showToolLen>=4&&!scope.row.isShow"
            :active-text="$t('common.active_text')"
            :inactive-text="$t('common.inactive_text')"
          >
          </el-switch>
        </el-tooltip>
        <el-tooltip
          class="item"
          v-else
          effect="dark"
          :disabled="!(scope.row.showToolLen>=6&&!scope.row.isShow)"
          :content="$t('management.menu.limit_prompt_level2')"
          placement="bottom"
        >
          <el-switch
            v-model="scope.row.isShow"
            @change="changeMenu(scope.row)"
            :disabled="scope.row.showToolLen>=6&&!scope.row.isShow"
            :active-text="$t('common.active_text')"
            :inactive-text="$t('common.inactive_text')"
          >
          </el-switch>
        </el-tooltip>
      </template>

    </el-table-column>
    <el-table-column
      prop="operate"
      :label="$t('management.menu.operate_label')"
      width="150"
    >
      <template slot-scope="scope">
        <el-button
          type="iconButton"
          icon="h-icon-arrow_up"
          class="operator-button"
          :disabled="scope.row.sortIndex === 0"
          :title="$t('management.menu.reorder_up_title')"
          @click="reorderMenu(scope.row, 'up')"
        >
        </el-button>
        <el-button
          type="iconButton"
          icon="h-icon-arrow_down"
          class="operator-button"
          :disabled="scope.row.sortIndex === data.length - 1"
          :title="$t('management.menu.reorder_down_title')"
          @click="reorderMenu(scope.row, 'down')"
        >
        </el-button>
        <el-button
          type="iconButton"
          icon="h-icon-trashcan"
          class="operator-button"
          :title="$t('management.menu.delete_title')"
          @click="removeMenu(scope.row.id)"
        >
        </el-button>
        <el-button
          type="iconButton"
          icon="h-icon-stick"
          :disabled="scope.row.children!==null"
          class="operator-button"
          :title="$t('management.menu.move_title')"
          @click="moveMenu(scope.row.id)"
        >
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import editableInfo from './editable-info'
import { fixedTableMixin } from 'utils/mixin'
import menuIconUpload from './menu-icon-upload'
export default {
  name: 'tree-grid',
  props: {
    data: Array,
    level: {
      type: Number,
      default: 1
    },
    selections: {
      type: Array,
      default: () => {
        return []
      }
    },
    showToolLen: {
      type: Number
    }
  },
  computed: {
    paddingWidth () {
      return (this.level - 1) * 32
    },
    newData () {
      let tempData = this.data
      tempData.forEach(item => {
        if (item.children) {
          let tempArr = []
          item.children.forEach(subItem => {
            if (subItem.isShow) {
              tempArr.push(subItem)
            }
          })
          item.children.forEach(subItem => {
            subItem.showToolLen = tempArr.length
          })
        }
      })
      return tempData
    }
  },
  methods: {
    _toggleSub (row) {
      if (!row.children || !row.children.length) return
      this.$nextTick(() => {
        const _flag = row._flag
        const subTable = this.$refs[`sub-table-${row.id}`]
        if (_flag) {
          if (row._selections.length === row.children.length) return
          if (subTable) {
            subTable.selectAll(true)
          } else if (row.children && row.children.length > 0) {
            let _arr = []
            for (let item of row.children) {
              _arr.push(item)
            }
            row._selections = _arr
          }
        } else {
          if (row._selections.length === 0) return
          if (subTable) {
            subTable.selectAll(false)
          } else if (row.children && row.children.length > 0) {
            row._selections = []
          }
        }
      })
    },
    getRowClassName (row) {
      return !row.children || row.children.length === 0 ? 'no-sub' : ''
    },
    onSelectionChange (selection) {
      for (let d of this.data) {
        let _f = false
        for (let s of selection) {
          if (s.id === d.id) {
            _f = true
          }
        }
        if (d._flag !== _f) {
          d._flag = _f
          this._toggleSub(d)
        }
      }
      this.$emit('selection-change', selection)
    },
    onSubSelection (selection, row) {
      row._selections = selection
    },
    selectAll (flag) {
      this.$refs.table.clearSelection()
      for (let row of this.data) {
        this.$refs.table.toggleRowSelection(row, flag)
        if (this.level !== 3 && row._flag === flag) {
          this._toggleSub(row)
        }
      }
    },
    getSelections () {
      let _selections = this.selections
      for (let row of this.data) {
        const subTable = this.$refs[`sub-table-${row.id}`]
        if (subTable) {
          _selections = _selections.concat(subTable.getSelections())
        }
      }
      return _selections
    },
    removeMenu (menuId) {
      this.$emit('remove-menu', menuId)
    },
    moveMenu (menuId) {
      this.$emit('move-menu', menuId)
    },
    changeMenu (menu) {
      this.$nextTick(() => {
        this.$emit('change-menu', menu)
      })
    },
    reorderMenu (menu, type) {
      this.$emit('reorder-menu', menu, type)
    },
    changeOpenType (menu) {
      if (menu.openType !== menu._openType) {
        this.$emit('change-menu', menu)
        menu._openType = menu.openType
      }
    },
    menu_level_name (value) {
      let _map = {
        1: this.$t('management.menu.menu_level_name1'),
        2: this.$t('management.menu.menu_level_name2'),
        3: this.$t('management.menu.menu_level_name3')
      }
      return _map[value]
    }
  },
  mounted () {
    this.$refs.table.clearSelection()
    if (this.selections.length) {
      for (let row of this.selections) {
        this.$refs.table.toggleRowSelection(row, true)
      }
    }
  },
  mixins: [fixedTableMixin],
  components: {
    editableInfo,
    menuIconUpload
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.operator-button {
  padding: 0;
  background-color: transparent;
}
</style>
